import { AnchoredRegion, anchoredRegionTemplate as template } from '@microsoft/fast-foundation';
import { css } from '@microsoft/fast-element';
import { AnchoredRegionComponent } from './AnchoredRegion';
import styles from './AnchoredRegion.styles.scss';
/**
 * DO NOT REMOVE:
 *
 * While `AnchoredRegion` may seem unused and ripe for removal,
 * it is actually a hidden dependency of `MenuItem`, see:
 *  - https://github.com/jive/chameleon/pull/2137#issuecomment-2769371510
 *  - https://github.com/microsoft/fast/blob/%40microsoft/fast-foundation_v2.47.0/packages/web-components/fast-foundation/src/menu-item/menu-item.template.ts#L80
 */
export const chameleonAnchorRegion = AnchoredRegionComponent.compose({
    baseName: 'anchor-region',
    baseClass: AnchoredRegion,
    template: template,
    styles: (ctx, def) => css `
    ${styles}
  `,
});
